/**
 *
 * @instance jQuery
 * @param {function} fn
 * @returns {jQuery}
 */
$.fn.or = function or(fn) {
    if (this.length) {
        return this;
    }

    else {
        return fn(this.end());
    }
};



// WEBPACK FOOTER //
// ./js/main/plugin/jquery.or.js